<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { useAuthStore } from '@/stores/auth.ts';
  import { computed } from 'vue';
  import { useThemeStore } from '@/stores/theme';

  interface Props {
    title?: string;
    goBack?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    title: '',
    goBack: false,
  });

  const router = useRouter();
  const auth = useAuthStore();
  const themeStore = useThemeStore();

  const isAuthorized = computed(() => {
    const current = router.currentRoute.value;
    if (!current.meta.role) return true;

    if (!auth.isUser) return false;

    if (
      current.meta.role == 'ORIGIN_OR_MANAGER' &&
      (auth.isOrigin || auth.isManager)
    )
      return true;

    if (current.meta.role == 'ORIGIN' && (auth.isOrigin || auth.isManager))
      return true;

    return current.meta.role == 'MANAGER' && auth.isManager;
  });
</script>

<template>
  <div
    class="md:sticky md:mockup-browser md:bg-base-300 md:max-w-lg md:m-auto md:my-10"
    :class="{
      'md:border': themeStore.isLight,
      'md:border md:border-neutral': themeStore.isDark,
    }">
    <div class="mockup-browser-toolbar" />

    <div class="bg-base-100 md:min-h-[70vh]">
      <AppHeader
        :title="title"
        :go-back="goBack" />

      <div class="pt-2 pb-16 px-5">
        <slot v-if="isAuthorized" />
        <UnauthorizedPage v-else />
      </div>
      <!--      <Spinner v-if="loading.isLoading" />-->

      <AppFooter />
      <AppNavbar />
    </div>
  </div>
</template>
